import { getStorage, ref, getDownloadURL } from "firebase/storage";

export function getStorageUrl(path) {
    const pathRef = ref(getStorage(), path);
    return getDownloadURL((pathRef));
}
